export default __webpack_public_path__ + "static/media/calendar.ca5633d6.png";